import { MerchantPolicyDbParser } from "@redotech/redo-model/merchant-policies/merchant-policy-db-parser";
import { array, object, null as zNull } from "zod";

export const getMerchantPolicies = {
  input: zNull(),
  output: object({ policies: array(MerchantPolicyDbParser).optional() }),
};
